import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { MycurrencyPipe } from './mycurrency.pipe';
@Directive({
  selector: '[appMycurrency]'
})
export class MycurrencyDirective implements OnInit {
  private el: any;
  maxLength: number;
  constructor(
    private elementRef: ElementRef,
    private formatcurrencypipe: MycurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
    this.maxLength = this.el.maxLength - 2;
  }
  ngOnInit() {
    setTimeout(() => {
      if (!this.el.value || this.el.value == '') {
        this.el.value = "$ "
      }
      else {
        this.el.value = this.formatcurrencypipe.transform(this.el.value, 0, this.maxLength);
      }
    })
  }
  @HostListener("focus", ["$event.target.value", "$event"])
  onFocus(value, event) {
    if (event.which == 9) {
      return false;
    }
    this.el.value = value.replace(/,/g, '');
    this.el.select();

  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    value = value.replace('>', '')
    let arrVal = value.split("$");

    if (arrVal[arrVal.length - 1].indexOf(',') > -1) {
      let commaArr = arrVal[arrVal.length - 1].split(",")
      this.el.value = this.formatcurrencypipe.transform(commaArr.join(''), 0, this.maxLength);
      return;

    } else {
      this.el.value = this.formatcurrencypipe.transform(arrVal[arrVal.length - 1], 0, this.maxLength);
    }
  }
  @HostListener('keydown', ['$event', "$event.target.value"]) onKeyDown(event, value) {
    let e = <KeyboardEvent>event;
    if (e.key == ".") {
      e.preventDefault();
      return;
    }

    if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39 && e.keyCode === 190)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (e.key == ".") {
      e.preventDefault();
      alert(e.which)
    }
    if (
      (e.keyCode === 190 && e.shiftKey) ||
      (e.keyCode === 190) ||
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) // block non-numeric
    ) {
      e.preventDefault();

    }
    if (value.length >= 2 && value.includes("$ ")) {
      value = value.substring(1, value.length)

    }
    value = value.replace(/[$]/gi, '');
    this.el.value = "$ " + value.trim(); // opossite of transform
  }

}